import { createFileRoute } from "@tanstack/react-router";
import { buttons } from "./-data/mock";
import FAQ from "./-components/faq";
import { useState } from "react";
import { Image } from "@/components/ui/image";
import { useNavigate } from "@tanstack/react-router";
import { AlarmWarningFill, Key2Fill, SmartPhoneFill, Spam2Fill } from "@/components/icons/svg.tsx";
import { useAuth } from "@repo/context/auth/auth";
import { LockKeyhole } from "lucide-react";
import { PulseLoader } from "react-spinners";
import { cn } from "@heroui/react";

export const Route = createFileRoute("/help/")({
  component: PageHelpCenter,
});


const menu = [
  {
    id: 1,
    title: "违规查询",
    icon: <Spam2Fill className={"text-gray-800"} />,
    nav: "",
    disabled: true,
  },
  {
    id: 2,
    title: "修改密码",
    icon: <Key2Fill className={"text-gray-800"} />,
    nav: "/f2a/otp?biz=reset_password&redirect=/user/account/changePass",
    disabled: false,
  },
  {
    id: 3,
    title: "手机换绑",
    icon: <SmartPhoneFill className={"text-gray-800"} />,
    nav: "/f2a/otp?biz=update_phone&redirect=/user/account/updatePhone",
    disabled: false,
  },
  {
    id: 4,
    title: "违规举报",
    icon: <AlarmWarningFill className={"text-gray-800"} />,
    nav: "/",
    disabled: true,
  },
];

export default function PageHelpCenter() {
  const [faqScope, setFaqScope] = useState("common");
  // 获取登录状态
  const { userInfo, loading } = useAuth()
  const isLogin = !!userInfo?.uid
  const navigate = useNavigate();
  return (
    <div className={"flex flex-col justify-center"}>
      <div
        className={
          "to-[rgba(245, 206, 224, 0)] flex justify-center bg-gradient-to-b from-[rgba(245,206,224,.4)]"
        }
      >
        <div className="overflow-hiddenoverflow-hidden mx-3 mt-[20px] inline-flex flex-grow flex-col items-center justify-between rounded-lg bg-white px-[26px] py-5 shadow-lg">
          <div className="mb-[8px] flex flex-col items-center justify-start gap-2.5">
            <div className="text-center text-xl font-bold text-black">欢迎来到帮助中心</div>
            <div className="text-center text-sm font-medium text-[#979797]">
              我们的部分自助服务还在开发中，先随便看看吧！
            </div>
          </div>
          {isLogin && !loading ? (
            <div className="inline-flex items-start justify-start">
              {menu.map((item) => {
                return (
                  <div
                    key={item.id}
                    className={cn(
                      "flex w-20 cursor-pointer items-center justify-center gap-2.5 rounded-md p-4 transition-all hover:bg-gray-100",
                      item.disabled && "cursor-not-allowed opacity-50",
                    )}
                    onClick={() => {
                      if (item.disabled) return;
                      navigate({ href: item.nav });
                    }}
                  >
                    <div className="inline-flex flex-col items-center justify-center gap-1.5 self-stretch overflow-hidden">
                      <div className={"h-6 w-6"}>{item.icon}</div>
                      <div className="self-stretch text-center text-xs font-normal text-black">
                        {item.title}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : !loading ? (
            <div className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-md my-4">
              <LockKeyhole className="text-gray-500" size={16} />
              <span className="text-sm text-gray-800">部分功能需要登录后使用</span>
            </div>
          ) :
            (
              <div className="flex items-center gap-2 py-2 my-4">
                <PulseLoader color="#000" size={4} />
                <span className="text-sm text-gray-800">加载自助功能...</span>
              </div>
            )}
        </div>
      </div>
      <div
        className={
          "relative m-3 flex h-28 cursor-pointer flex-col justify-around overflow-hidden rounded-lg bg-white shadow-lg"
        }
        onClick={() =>
          window.open(
            "mqqapi://card/show_pslcard?src_type=internal&version=1&uin=908274958&key=44a6e01f2dab126f87ecd2ec7b7e66ae259b30535fd0c2c25776271e8c0ac08f&card_type=group&source=external",
          )
        }
      >
        <div className={"z-20 px-6"} onClick={() =>
          window.open("https://qun.qq.com/universal-share/share?ac=1&authKey=oRiH4pAbrCOktmtGodMGQGLFkTa9iZE5wHbFYY3zVwvAQcvGshON%2FeuOfE%2BZg%2B8x&busi_data=eyJncm91cENvZGUiOiI5MDgyNzQ5NTgiLCJ0b2tlbiI6Ik1jR1FKQ0o2WGd4ejg4T1h6Ym5wbEpsRE5tR0JsaitCTHdSUnVZWkJJSUdpVjhXNFRvTTdYMVVVTzFiZmVScG8iLCJ1aW4iOiIxMzMwNDQwMDExIn0%3D&data=UIA3C56Fd_qkcfXQcY2ZBLXoatme7slazMlpIkFmRMcxbXaTVtuti9JdstenzWVjI3kDJycypH0ha3itZqOT1A&svctype=4&tempid=h5_group_info", "_blank")}>
          <div className={"mb-1 text-xl font-bold"}>需要我们的帮助吗？</div>
          <div>
            官方一对一服务QQ群：<span className={"text-primary bg-white p-1 px-2 rounded-lg"}>908274958</span>
          </div>
        </div>
        <div className={"absolute right-4 opacity-40"}>
          <Image src={"./img/customer_service_avatar.png"} className="h-48" />
        </div>
      </div>
      {/* <section className="px-3">
        <Alert className=" text-red-500" variant="flat" color="danger" title="反诈提醒"
          description={"近期出现不法分子以“画师未通过平台收款认证”为由引导画师扫码通过站外联系或是通过冒充假客服引导站外交易，各位小动物们请注意甄别，谨防被骗！"}
          endContent={<Button color="danger" variant="flat" size="sm"
            onPress={() => navigate({ to: "/notice/span_warning" })}>查看详情</Button>} />
      </section> */}
      <div className="inline-flex flex-col items-start justify-start gap-2.5 overflow-hidden bg-white p-3">
        <div className="h-8 text-center text-lg font-medium text-black">常见问题</div>
        <div className="scrollbar-hide w-full items-start justify-start overflow-scroll">
          <div className="ml-3 flex flex-row gap-4">
            {buttons.map((button) => (
              <div
                className={cn(
                  "cursor-pointer text-sm",
                  faqScope === button.key ? "text-orange-500" : "#333",
                )}
                key={button.key}
                onClick={() => {
                  if (button.disabled) return;
                  setFaqScope(button.key);
                }}
                style={{
                  opacity: button.disabled ? 0.5 : 1,
                  cursor: button.disabled ? "not-allowed" : "pointer",
                }}
              >
                {button.title}
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col items-center justify-start gap-2.5 self-stretch">
          <FAQ scope={faqScope} />
        </div>
      </div>
    </div>
  );
}
